export enum GenerationsType {
  Free = 1,
  Paid = 2,
}
